import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { useAppSelector, PrivateRoute, appRoutes } from '@/shared';
import { selectIsAuth } from '@/modules/auth';
import { selectUserRole } from '@/modules/profile';

import {
  Login,
  Dashboard,
  // Home,
  // Payments,
  // Withdrawals,
  // Config,
  // Users,
  // Shops,
  // ShopCommissions,
  // Transactions,
  // PaymentSystems,
  // PaymentMethods,
  // WithdrawalMethods,
  // Whitelist,
  NotFound,
} from '@/pages';

export const AppRouter = () => {
  const isAuth = useAppSelector(selectIsAuth);
  const role = useAppSelector(selectUserRole);
  const isAdmin = (role === 'admin' || role === 'operator') && isAuth;

  return (
    <BrowserRouter>
      <Routes>
        <Route path={appRoutes.login} element={<Login isAuth={isAdmin} />} />
        <Route path="/" element={<Navigate to={`/${appRoutes.dashboard}`} replace />} />

        <Route
          path={`${appRoutes.dashboard}/*`}
          // path={appRoutes.dashboard}
          element={(
            <PrivateRoute isAccountLoading={false} isAuth={isAuth}>
              <Dashboard />
            </PrivateRoute>
          )}
        />
        {/* <Route index element={<Home />} />
          <Route path={appRoutes.payments} element={<Payments />} />
          <Route path={appRoutes.withdrawals} element={<Withdrawals />} />
          <Route path={appRoutes.config} element={<Config />} />
          <Route path={appRoutes.users} element={<Users />} />
          <Route path={appRoutes.shops} element={<Shops />} />
          <Route path={appRoutes.shopCommissions} element={<ShopCommissions />} />
          <Route path={appRoutes.transactions} element={<Transactions />} />
          <Route path={appRoutes.paymentSystems} element={<PaymentSystems />} />
          <Route path={appRoutes.paymentMethods} element={<PaymentMethods />} />
          <Route path={appRoutes.withdrawalMethods} element={<WithdrawalMethods />} />
          <Route path={appRoutes.whitelist} element={<Whitelist />} /> */}
        {/* </Route> */}

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
};
